module.exports = __webpack_public_path__ + "src/assets/games/42/39.jpg";